import { Card, Col, Input, Label, Row } from "reactstrap";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { companiesHouseGovUKSearchCompanies } from "../../../store/companiesHouseGovUK/action";
import CompaniesHouseGovUK from "../../../store/companiesHouseGovUK/reducer";
import { preventDefault } from "@fullcalendar/react";
import "./createNewCompany.styles.css";
import ClickOutside from "../../Common/ClickOutsideComponent";
// Change #100462 - Enterprise billing, CRMit staff only
import { toast } from "react-toastify";
import { isDeveloperUser } from "../../../helpers/functions/developerFlag";
import BillingModeSection, { validateBillingMode } from "./billingModeSection";
export function BusinessDetailsTab({
  createCompanyData,
  setCreateCompanyData,
  toggle,
  activeTab,
  handleCheckEachStep,
  handleCreateCompany,
}) {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const { companies, loading } = useSelector((state) => ({
    companies: state.CompaniesHouseGovUK.companies,
    loading: state.CompaniesHouseGovUK.loading,
  }));
  const [showResults, setShowResults] = useState(false);
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (isEmpty(searchQuery)) return;
      dispatch(companiesHouseGovUKSearchCompanies({ id: searchQuery }));
    }, 500);
    return () => clearTimeout(delay);
  }, [searchQuery]);

  console.log("showResults", showResults);
  const [selectCompanyFromSearch, setSelectCompanyFromSearch] = useState(null);
  console.log("selectCompanyFromSearch", selectCompanyFromSearch);
  return (
    <div className={"w-100"}>
      <ClickOutside
        onClick={() => {
          setShowResults(false);
        }}
      >
        <div className={"d-flex flex-column w-100"}>
          <div className={"w-100"}>
            <Label>
              Search Business Name
              <span className={"text-danger"}>*</span>
            </Label>
            <Input
              Cle
              onFocus={() => {
                setShowResults(true);
              }}
              onBlur={() => {
                setTimeout(() => {
                  setShowResults(false);
                }, 500);
              }}
              type="search"
              className={"form-control"}
              value={createCompanyData?.BusinessName}
              onChange={(e) => {
                if (!e.target.value) {
                  setCreateCompanyData({
                    ...createCompanyData,
                    BusinessName: "",
                  });
                  setSelectCompanyFromSearch(null);
                }
                setCreateCompanyData({
                  ...createCompanyData,
                  BusinessName: e.target.value,
                });
                handleSearch(e);
              }}
            />
          </div>
          <div>
            {searchQuery.length > 0 && showResults && (
              <div>Companies house search results</div>
            )}
            {showResults && (
              <div className={"pb-2 company-house-response-list"}>
                {companies?.items?.map((item, index) => {
                  return (
                    <Card
                      key={index}
                      className={
                        "d-flex flex-row justify-content-between align-items-center"
                      }
                    >
                      <div className={"d-flex flex-column flex-wrap p-2"}>
                        <div>{item.title}</div>

                        <div>{item.description}</div>
                        <div>
                          {item?.address?.address_line_1 ?? ""}{" "}
                          {item?.address?.address_line_2 ?? ""}{" "}
                          {item?.address?.locality ?? ""}{" "}
                          {item?.address?.postal_code ?? ""}
                        </div>
                      </div>
                      <div>
                        <span
                          className={"btn btn-sm btn-primary me-2"}
                          onClick={() => {
                            setCreateCompanyData({
                              ...createCompanyData,
                              BusinessName: item?.title ?? "",
                              RegNo: item?.company_number ?? "",
                              AddressLine1:
                                (item?.address?.premises ?? "") +
                                " " +
                                (item?.address?.address_line_1 ?? ""),
                              AddressLine2: item?.address?.address_line_2 ?? "",
                              AddressCountry: item?.address?.country ?? "",
                              AddressCity: item?.address?.locality ?? "",
                              AddressPostCode: item?.address?.postal_code ?? "",
                            });
                            setSearchQuery("");
                            setShowResults(false);
                            setSelectCompanyFromSearch(item);
                          }}
                        >
                          Select
                        </span>
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </ClickOutside>
      {!showResults && !isEmpty(selectCompanyFromSearch) && (
        <div className={"pt-2"}>
          <hr />
          <div className={"d-flex flex-column w-100"}>
            <div className={"w-100"}>
              <Label title={"Required"}>
                Business Name
                <span className={"text-danger"}>*</span>
              </Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData.BusinessName}
                onChange={(e) => {
                  {
                    setCreateCompanyData({
                      ...createCompanyData,
                      BusinessName: e.target.value,
                    });
                  }
                }}
              />
            </div>

            <div className={"w-100 mt-2"}>
              <Label>Registration Number</Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData?.RegNo}
                onChange={(e) => {
                  {
                    setCreateCompanyData({
                      ...createCompanyData,
                      RegNo: e.target.value,
                    });
                  }
                }}
              />
            </div>

            <div className={"w-100 mt-2"}>
              <Label>Address 1st Line</Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData.AddressLine1}
                onChange={(e) => {
                  {
                    setCreateCompanyData({
                      ...createCompanyData,
                      AddressLine1: e.target.value,
                    });
                  }
                }}
              />
            </div>
            <div className={"w-100 mt-2"}>
              <Label>Address 2nd Line</Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData.AddressLine2}
                onChange={(e) => {
                  {
                    setCreateCompanyData({
                      ...createCompanyData,
                      AddressLine2: e.target.value,
                    });
                  }
                }}
              />
            </div>
            <div className={"w-100 mt-2"}>
              <Label>City</Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData.AddressCity}
                onChange={(e) => {
                  setCreateCompanyData({
                    ...createCompanyData,
                    AddressCity: e.target.value,
                  });
                }}
              />
            </div>
            <div className={"w-100 mt-2"}>
              <Label>Postcode</Label>
              <input
                type="text"
                className={"form-control"}
                value={createCompanyData.AddressPostCode}
                onChange={(e) => {
                  setCreateCompanyData({
                    ...createCompanyData,
                    AddressPostCode: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div></div>

      {isDeveloperUser() && (
        <BillingModeSection
          createCompanyData={createCompanyData}
          setCreateCompanyData={setCreateCompanyData}
        />
      )}

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab nexttab"
          onClick={() => {
            const billingError = isDeveloperUser() ? validateBillingMode(createCompanyData) : "";
            if (billingError) {
              toast.error(billingError);
              return;
            }
            handleCreateCompany();
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Create Business
        </button>
      </div>
    </div>
  );
}
